import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { NitroButton } from 'nitro-components';
import { Table, TableBody, TableHeader } from 'material-ui/Table';
import MockRows from './mockRows';
import Tabs from '../../components/common/tabs';
import FuelCardTableHeader from './fuel-card-table/fuel-card-table-header';
import FuelCardTableRow from './fuel-card-table/fuel-card-table-row';
import RequestLogTableHeader from './request-log-table/request-log-table-header';
import RequestLogTableRow from './request-log-table/request-log-table-row';
import { tableHeaderStyles, FuelCardInput } from './styles';
import OrderFuelCard from './order-fuel-card';

const PageContainer = styled.div`
  padding: 16px 0;
`;

const Page = styled.div`
  background: ${props => props.theme.color.white};
  padding: 24px;
`;

const Header = styled.h6`
  font-family: ${props => props.theme.font.bold};
  color: ${props => props.theme.color.grey9};
  font-size: 18px;
  letter-spacing: 0.2px;
  margin: 0 0 16px;
`;

const TabsContainer = styled.div`
  border-bottom: 1px solid ${props => props.theme.color.veryLightBlue};
`;

const TableActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
`;

const TableButton = styled(NitroButton)`
  font-size: 12px;
`;

const FUEL_CARD_TAB = { id: 'FUEL_CARD', title: 'CARDS' };
const REQUEST_LOG_TAB = { id: 'REQUEST_LOG', title: 'REQUEST LOG' };
const TABS = [FUEL_CARD_TAB, REQUEST_LOG_TAB];

const tableHeaderComponents = {
  [FUEL_CARD_TAB.id]: FuelCardTableHeader,
  [REQUEST_LOG_TAB.id]: RequestLogTableHeader
};

const tableRowComponents = {
  [FUEL_CARD_TAB.id]: FuelCardTableRow,
  [REQUEST_LOG_TAB.id]: RequestLogTableRow
};

class FuelCards extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      search: '',
      loading: false,
      activeTab: TABS[0],
      ordering: false,
      cancelling: null,
      orderModalOpen: false
    };

    this.changeTab = this.changeTab.bind(this);
    this.orderFuelCard = this.orderFuelCard.bind(this);
    this.cancelFuelCard = this.cancelFuelCard.bind(this);
    this.updateSearch = this.updateSearch.bind(this);
  }

  orderFuelCard = () => {
    this.setState({ ordering: true });
    setTimeout(() => {
      this.setState({ orderModalOpen: false, ordering: false });
    }, 2000);
  };

  cancelFuelCard = fuelCard => {
    this.setState({ cancelling: fuelCard.id });
    setTimeout(() => this.setState({ cancelling: null }), 2000);
  };

  changeTab(tab) {
    this.setState({ activeTab: tab, search: '' });
  }

  updateSearch = e => {
    this.setState({ search: e.target.value });
  };

  render() {
    const {
      activeTab,
      search,
      loading,
      cancelling,
      orderModalOpen,
      ordering
    } = this.state;
    const HeaderComponent = tableHeaderComponents[activeTab.id];
    const RowComponent = tableRowComponents[activeTab.id];

    return (
      <PageContainer>
        <Page>
          <Header>Fuel Cards</Header>
          <TabsContainer>
            <Tabs
              activeKey={activeTab.id}
              tabs={TABS}
              onClick={this.changeTab}
            />
          </TabsContainer>
          <TableActions>
            <FuelCardInput
              underlineShow={false}
              placeholder="Search"
              value={search}
              onChange={this.updateSearch}
            />
            <div>
              <TableButton
                action={() => this.setState({ orderModalOpen: true })}
                size="extraSmall"
                label="ORDER FUEL CARD"
                variant="primary"
              />
            </div>
          </TableActions>
          <Table>
            <TableHeader
              style={tableHeaderStyles}
              displaySelectAll={false}
              adjustForCheckbox={false}>
              <HeaderComponent />
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
              {loading ? <div>Loading</div> : null}
              {MockRows.map(fuelCard => (
                <RowComponent
                  key={fuelCard.fuelCardNumber}
                  fuelCard={fuelCard}
                  loadingAction={cancelling === fuelCard.id}
                  disableAction={cancelling !== null}
                  onCancel={this.cancelFuelCard}
                />
              ))}
            </TableBody>
          </Table>
        </Page>
        <OrderFuelCard
          open={orderModalOpen}
          ordering={ordering}
          onOrder={this.orderFuelCard}
          onClose={() => this.setState({ orderModalOpen: false })}
        />
      </PageContainer>
    );
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {})(FuelCards);



// WEBPACK FOOTER //
// ./src/features/fuel-cards/index.js